let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kcin7")).then(() => parcelRequire('lOkzM'));